// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import { Button } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font: string; // 예: "Noto Sans KR 28px"
//   color: string;
// }

// interface LayoutConfig {
//   texts: LayoutText[];
//   bg_image?: string;
// }

// const RecordPhotoPrint: React.FC = () => {
//   const { bibNum } = useParams<{ bibNum?: string }>();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const stateData = (location.state as any) || {};

//   // 참가자 정보
//   const [userName] = useState(stateData.userName || '이름 없음');
//   const [userBib] = useState(stateData.compBib || (bibNum || '-'));
//   const [compDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);

//   useEffect(() => {
//     if (stateData.compCode) setCompCodeState(stateData.compCode);
//   }, [stateData.compCode]);

//   // 폰트 파싱
//   const parseFont = (font: string): { family: string; size: number } => {
//     const parts = (font || '').trim().split(/\s+/);
//     if (parts.length === 0) return { family: 'Arial', size: 20 };

//     const last = parts[parts.length - 1]; // ex) "28px"
//     const size = parseInt(last.replace('px', ''), 10);
//     const family = parts.slice(0, -1).join(' ') || 'Arial';

//     return { family, size: Number.isFinite(size) ? size : 20 };
//   };

//   // 레이아웃 로드
//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);

//   useEffect(() => {
//     if (!compCodeState) return;

//     axios
//       .get(`/api/get-layout/${compCodeState}?mode=photo`)
//       .then((res) => {
//         const raw = res.data;
//         let texts: LayoutText[] = [];
//         if (raw.layout_config) {
//           try {
//             texts = JSON.parse(raw.layout_config).texts || [];
//           } catch {
//             // ignore
//           }
//         }
//         setLayoutConfig({ bg_image: raw.bg_image, texts });
//       })
//       .catch(console.error);
//   }, [compCodeState]);

//   // 배경 URL
//   const backgroundUrl = layoutConfig?.bg_image ? `/static/images/${layoutConfig.bg_image}` : defaultBackground;

//   // A4 캔버스 크기 (portrait/landscape)
//   const [canvasWidth, setCanvasWidth] = useState(595);
//   const [canvasHeight, setCanvasHeight] = useState(842);

//   // 이미지 로딩 플래그
//   const [bgReady, setBgReady] = useState(false);
//   const [userReady, setUserReady] = useState(false);

//   useEffect(() => {
//     setBgReady(false);
//     const img = new Image();
//     img.src = backgroundUrl;
//     img.onload = () => {
//       setBgReady(true);
//       if (img.naturalWidth > img.naturalHeight) {
//         setCanvasWidth(842);
//         setCanvasHeight(595);
//       } else {
//         setCanvasWidth(595);
//         setCanvasHeight(842);
//       }
//     };
//   }, [backgroundUrl]);

//   // ✅ 모바일 잘림 방지: 보여줄 때만 스케일링
//   const wrapperRef = useRef<HTMLDivElement>(null);
//   const [viewScale, setViewScale] = useState(1);

//   useEffect(() => {
//     const updateScale = () => {
//       if (!wrapperRef.current) return;

//       // wrapper가 가질 수 있는 폭(부모 폭)
//       const parentWidth = wrapperRef.current.clientWidth;

//       // 좌우 여백(패딩/버튼 고려)
//       const targetWidth = Math.max(parentWidth - 16, 0);

//       // 캔버스가 화면을 넘지 않게 축소(PC에선 1 유지)
//       const s = Math.min(targetWidth / canvasWidth, 1);

//       setViewScale(s);
//     };

//     updateScale();
//     window.addEventListener('resize', updateScale);
//     window.addEventListener('orientationchange', updateScale);

//     return () => {
//       window.removeEventListener('resize', updateScale);
//       window.removeEventListener('orientationchange', updateScale);
//     };
//   }, [canvasWidth, canvasHeight]);

//   // 서버 이미지 갤러리
//   const [serverImages, setServerImages] = useState<string[]>([]);

//   useEffect(() => {
//     if (!userBib || !compCodeState) return;

//     axios
//       .get<string[]>(`/api/get-bib-images/${compCodeState}/${userBib}`)
//       .then((res) => setServerImages(res.data))
//       .catch(console.error);
//   }, [userBib, compCodeState]);

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const pageSize = 2;
//   const visible = serverImages.slice(currentIndex, currentIndex + pageSize);
//   const prevPage = () => setCurrentIndex((i) => Math.max(i - pageSize, 0));
//   const nextPage = () => setCurrentIndex((i) => Math.min(i + pageSize, Math.max(serverImages.length - pageSize, 0)));

//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalUrl, setModalUrl] = useState('');
//   const [zoom, setZoom] = useState(1);

//   const openModal = (url: string) => {
//     setModalUrl(url);
//     setZoom(1);
//     setModalOpen(true);
//   };
//   const closeModal = () => setModalOpen(false);

//   // 업로드
//   const [tempImageUrl, setTempImageUrl] = useState('');
//   const [userImageUrl, setUserImageUrl] = useState('');
//   const canvasRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     setUserReady(false);
//   }, [userImageUrl]);

//   const handleTempFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) setTempImageUrl(URL.createObjectURL(file));
//   };

//   const handleUploadClick = () => {
//     if (tempImageUrl) {
//       setUserImageUrl(tempImageUrl);
//       setTempImageUrl('');
//     }
//   };

//   // 이미지 다운로드 (갤러리 원본)
//   const handleDownloadImage = async (url: string) => {
//     try {
//       const resp = await axios.get(url, { responseType: 'blob' });
//       const blobUrl = URL.createObjectURL(resp.data);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = url.split('/').pop() || 'image.jpg';
//       link.click();
//       URL.revokeObjectURL(blobUrl);
//     } catch {
//       // ignore
//     }
//   };

//   // 사진 슬롯 (좌측 흰 박스)
//   const PHOTO_SLOT = {
//     left: 46,
//     top: 60,
//     width: 315,
//     height: 451,
//   };

//   // 캡처
//   const captureCanvas = async (): Promise<string | null> => {
//     if (!canvasRef.current) return null;

//     if (document.fonts?.ready) {
//       await document.fonts.ready;
//     }

//     const canvas = await html2canvas(canvasRef.current, {
//       scale: 4,
//       useCORS: true,
//       backgroundColor: null,
//       onclone: (clonedDoc) => {
//         const overlays = clonedDoc.querySelectorAll<HTMLElement>('.overlay-text');
//         overlays.forEach((el) => {
//           const cs = clonedDoc.defaultView?.getComputedStyle(el);
//           if (!cs) return;
//           const top = parseFloat(cs.top || '0');
//           el.style.top = `${top - 11}px`;
//         });
//       },
//     });

//     return canvas.toDataURL('image/png');
//   };

//   const handleDownload = async () => {
//     const dataUrl = await captureCanvas();
//     if (!dataUrl) return;

//     const link = document.createElement('a');
//     link.href = dataUrl;
//     link.download = '사진기록증.png';
//     link.click();
//   };

//   const handleReset = () => {
//     setUserImageUrl('');
//     setTempImageUrl('');
//   };

//   // 레이아웃 없는 대회 예외 처리
//   if (!userImageUrl && layoutConfig === null) {
//     return (
//       <div className="flex justify-center items-start h-screen bg-white pt-40">
//         <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">이번 대회에서는 사진 기록증을 서비스하지 않습니다.</h1>
//       </div>
//     );
//   }

//   // 초기 화면: 갤러리 + 업로드
//   if (!userImageUrl) {
//     const imgSize = 320;

//     return (
//       <div className="flex flex-col items-center">
//         <div className="flex items-center mb-4">
//           <Button size="sm" onClick={prevPage} disabled={!visible.length || currentIndex === 0}>
//             ◀
//           </Button>

//           <div className="flex mx-2">
//             {visible.map((fn, idx) => {
//               const url = `/static/images/${compCodeState}/${fn}`;
//               return (
//                 <div key={idx} className="flex flex-col items-center m-2">
//                   <img
//                     src={url}
//                     alt="gallery"
//                     style={{ width: imgSize, height: 'auto', objectFit: 'cover', cursor: 'pointer' }}
//                     onClick={() => openModal(url)}
//                   />
//                   <div className="mt-2 flex space-x-2">
//                     <Button size="sm" onClick={() => setUserImageUrl(url)}>
//                       기록증 만들기
//                     </Button>
//                     <Button size="sm" onClick={() => handleDownloadImage(url)}>
//                       다운로드
//                     </Button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <Button size="sm" onClick={nextPage} disabled={currentIndex + pageSize >= serverImages.length}>
//             ▶
//           </Button>
//         </div>

//         {modalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="relative flex justify-center items-center max-w-[80vw] max-h-[80vh]">
//               <img
//                 src={modalUrl}
//                 alt="enlarged"
//                 style={{
//                   maxWidth: '50%',
//                   maxHeight: '50%',
//                   transform: `scale(${zoom})`,
//                   transformOrigin: 'center center',
//                 }}
//                 onWheel={(e) => {
//                   e.preventDefault();
//                   setZoom((z) => Math.min(Math.max(z + (e.deltaY > 0 ? -0.1 : 0.1), 0.5), 3));
//                 }}
//               />
//               <div className="absolute bottom-2 center-2 flex space-x-2">
//                 <Button size="sm" onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
//                   +
//                 </Button>
//                 <Button size="sm" onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
//                   -
//                 </Button>
//                 <Button size="sm" onClick={closeModal}>
//                   닫기
//                 </Button>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="w-full px-6 py-4 mt-6" style={{ backgroundColor: '#e5f1ff' }}>
//           <p className="text-center mb-3 font-medium">현장 촬영 사진으로 기록증 등록 가능합니다.</p>
//           <div className="flex items-center justify-center space-x-4">
//             <span className="font-medium">사진 등록</span>
//             <input type="file" accept="image/*" onChange={handleTempFileChange} />
//             <Button variant="filled" color="blue" onClick={handleUploadClick} disabled={!tempImageUrl}>
//               올리기
//             </Button>
//             <Button variant="outlined" onClick={() => navigate(-1)}>
//               이전
//             </Button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // 기록증 뷰
//   const mapping: Record<string, string> = {
//     name: userName,
//     bib: userBib,
//     div: compDivLs,
//     time: compRecord,
//   };

//   return (
//     <div className="flex flex-col items-center">
//       {/* ✅ 모바일에서 화면 폭 안에 들어오게 스케일링하는 wrapper */}
//       <div
//         ref={wrapperRef}
//         style={{
//           width: '100%',
//           maxWidth: canvasWidth, // PC에서는 원래 사이즈 유지
//           padding: '0 8px',
//           boxSizing: 'border-box',
//         }}
//       >
//         {/* ✅ 스케일 적용 후 실제 표시 영역 크기 */}
//         <div
//           style={{
//             width: canvasWidth * viewScale,
//             height: canvasHeight * viewScale,
//             margin: '0 auto',
//           }}
//         >
//           {/* ✅ 내부는 원본 좌표계 유지 + transform으로만 축소 */}
//           <div
//             ref={canvasRef}
//             className="mt-2 mb-4 md:mt-8"
//             style={{
//               position: 'relative',
//               width: canvasWidth,
//               height: canvasHeight,
//               backgroundColor: '#fff',
//               transform: `scale(${viewScale})`,
//               transformOrigin: 'top left',
//             }}
//           >
//             {/* 배경 */}
//             <img
//               src={backgroundUrl}
//               alt="background"
//               onLoad={() => setBgReady(true)}
//               style={{
//                 position: 'absolute',
//                 inset: 0,
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//               }}
//             />

//             {/* 텍스트 오버레이 */}
//             {layoutConfig?.texts.map((item, idx) => {
//               const { family, size } = parseFont(item.font);
//               return (
//                 <div
//                   key={idx}
//                   className="overlay-text"
//                   style={{
//                     position: 'absolute',
//                     left: item.x,
//                     top: item.y,
//                     transform: 'translate(-50%, 0)',
//                     textAlign: 'center',
//                     fontFamily: family,
//                     fontSize: size,
//                     color: item.color,
//                     whiteSpace: 'nowrap',
//                   }}
//                 >
//                   {mapping[item.custom_id] || item.text}
//                 </div>
//               );
//             })}

//             {/* 사용자 사진 (background-image 방식) */}
//             <div
//               style={{
//                 position: 'absolute',
//                 left: PHOTO_SLOT.left,
//                 top: PHOTO_SLOT.top,
//                 width: PHOTO_SLOT.width,
//                 height: PHOTO_SLOT.height,
//                 overflow: 'hidden',
//                 border: '2px solid #fff',
//                 boxShadow: '0 0 8px rgba(0,0,0,0.35)',
//                 background: '#fff',
//               }}
//             >
//               <div
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   backgroundImage: `url("${userImageUrl}")`,
//                   backgroundRepeat: 'no-repeat',
//                   backgroundPosition: 'center',
//                   backgroundSize: 'contain',
//                 }}
//                 ref={(el) => {
//                   if (!el) return;
//                   const img = new Image();
//                   img.onload = () => setUserReady(true);
//                   img.src = userImageUrl;
//                 }}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex space-x-4 mb-8">
//         <Button variant="filled" color="blue" onClick={handleDownload}>
//           다운로드
//         </Button>
//         <Button variant="outlined" onClick={handleReset}>
//           이전화면
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default RecordPhotoPrint;

// 여수마라톤에만 적용, 추후 확장해야함


// import React, { useState, useEffect, useRef } from 'react';
// import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import html2canvas from 'html2canvas';
// import axios from 'axios';
// import { Button } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font: string; // 예: "Noto Sans KR 28px"
//   color: string;
// }

// interface LayoutConfig {
//   texts: LayoutText[];
//   bg_image?: string;
// }

// /**
//  * 창원 3·15 마라톤 기록증용 사진 슬롯
//  * 원본 템플릿 기준 해상도: 2048 x 1449
//  * 좌측 흰 박스 영역
//  */
// const TEMPLATE_SIZE = { w: 2048, h: 1449 };
// const PHOTO_BOX_TEMPLATE = {
//   x1: 70,
//   y1: 336,
//   x2: 1105,
//   y2: 1283,
// };

// const RecordPhotoPrint: React.FC = () => {
//   const { bibNum } = useParams<{ bibNum?: string }>();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const stateData = (location.state as any) || {};

//   // 참가자 정보
//   const [userName] = useState(stateData.userName || '이름 없음');
//   const [userBib] = useState(stateData.compBib || bibNum || '-');
//   const [compDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);

//   useEffect(() => {
//     if (stateData.compCode) setCompCodeState(stateData.compCode);
//   }, [stateData.compCode]);

//   // 폰트 파싱
//   const parseFont = (font: string): { family: string; size: number } => {
//     const parts = (font || '').trim().split(/\s+/);
//     if (parts.length === 0) return { family: 'Arial', size: 20 };

//     const last = parts[parts.length - 1]; // ex) "28px"
//     const size = parseInt(last.replace('px', ''), 10);
//     const family = parts.slice(0, -1).join(' ') || 'Arial';

//     return { family, size: Number.isFinite(size) ? size : 20 };
//   };

//   // 레이아웃 로드
//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);

//   useEffect(() => {
//     if (!compCodeState) return;

//     axios
//       .get(`/api/get-layout/${compCodeState}?mode=photo`)
//       .then((res) => {
//         const raw = res.data;
//         let texts: LayoutText[] = [];

//         if (raw.layout_config) {
//           try {
//             texts = JSON.parse(raw.layout_config).texts || [];
//           } catch {
//             // ignore
//           }
//         }
//         setLayoutConfig({ bg_image: raw.bg_image, texts });
//       })
//       .catch(console.error);
//   }, [compCodeState]);

//   // 배경 URL
//   const backgroundUrl = layoutConfig?.bg_image ? `/static/images/${layoutConfig.bg_image}` : defaultBackground;

//   // A4 캔버스 크기 (portrait/landscape)
//   const [canvasWidth, setCanvasWidth] = useState(595);
//   const [canvasHeight, setCanvasHeight] = useState(842);

//   // 이미지 로딩 플래그
//   const [bgReady, setBgReady] = useState(false);
//   const [userReady, setUserReady] = useState(false);

//   // ✅ 배경 원본 해상도 저장 (이번 템플릿에선 1454x2047일 가능성이 높음)
//   const [bgNatural, setBgNatural] = useState<{ w: number; h: number } | null>(null);

//   useEffect(() => {
//     setBgReady(false);
//     const img = new Image();
//     img.src = backgroundUrl;

//     img.onload = () => {
//       setBgReady(true);
//       setBgNatural({ w: img.naturalWidth, h: img.naturalHeight });

//       // portrait/landscape 판단
//       if (img.naturalWidth > img.naturalHeight) {
//         setCanvasWidth(842);
//         setCanvasHeight(595);
//       } else {
//         setCanvasWidth(595);
//         setCanvasHeight(842);
//       }
//     };
//   }, [backgroundUrl]);

//   // ✅ 모바일 잘림 방지: 보여줄 때만 스케일링
//   const wrapperRef = useRef<HTMLDivElement>(null);
//   const [viewScale, setViewScale] = useState(1);

//   useEffect(() => {
//     const updateScale = () => {
//       if (!wrapperRef.current) return;

//       const parentWidth = wrapperRef.current.clientWidth;
//       const targetWidth = Math.max(parentWidth - 16, 0);
//       const s = Math.min(targetWidth / canvasWidth, 1);

//       setViewScale(s);
//     };

//     updateScale();
//     window.addEventListener('resize', updateScale);
//     window.addEventListener('orientationchange', updateScale);

//     return () => {
//       window.removeEventListener('resize', updateScale);
//       window.removeEventListener('orientationchange', updateScale);
//     };
//   }, [canvasWidth, canvasHeight]);

//   // 서버 이미지 갤러리
//   const [serverImages, setServerImages] = useState<string[]>([]);

//   useEffect(() => {
//     if (!userBib || !compCodeState) return;

//     axios
//       .get<string[]>(`/api/get-bib-images/${compCodeState}/${userBib}`)
//       .then((res) => setServerImages(res.data))
//       .catch(console.error);
//   }, [userBib, compCodeState]);

//   const [currentIndex, setCurrentIndex] = useState(0);
//   const pageSize = 2;
//   const visible = serverImages.slice(currentIndex, currentIndex + pageSize);
//   const prevPage = () => setCurrentIndex((i) => Math.max(i - pageSize, 0));
//   const nextPage = () => setCurrentIndex((i) => Math.min(i + pageSize, Math.max(serverImages.length - pageSize, 0)));

//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalUrl, setModalUrl] = useState('');
//   const [zoom, setZoom] = useState(1);

//   const openModal = (url: string) => {
//     setModalUrl(url);
//     setZoom(1);
//     setModalOpen(true);
//   };
//   const closeModal = () => setModalOpen(false);

//   // 업로드
//   const [tempImageUrl, setTempImageUrl] = useState('');
//   const [userImageUrl, setUserImageUrl] = useState('');
//   const canvasRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     setUserReady(false);
//   }, [userImageUrl]);

//   const handleTempFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) setTempImageUrl(URL.createObjectURL(file));
//   };

//   const handleUploadClick = () => {
//     if (tempImageUrl) {
//       setUserImageUrl(tempImageUrl);
//       setTempImageUrl('');
//     }
//   };

//   // 이미지 다운로드 (갤러리 원본)
//   const handleDownloadImage = async (url: string) => {
//     try {
//       const resp = await axios.get(url, { responseType: 'blob' });
//       const blobUrl = URL.createObjectURL(resp.data);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = url.split('/').pop() || 'image.jpg';
//       link.click();
//       URL.revokeObjectURL(blobUrl);
//     } catch {
//       // ignore
//     }
//   };

//   /**
//    * ✅ 이번 템플릿 전용 PHOTO SLOT 계산
//    * - 템플릿 좌표(1454x2047)를 캔버스(595x842 or 842x595)로 스케일 변환
//    * - bgNatural이 없거나 템플릿 크기가 달라도, "이번엔 이 템플릿만" 전제로 TEMPLATE_SIZE 사용
//    */
//   const getPhotoSlot = () => {
//     // 이번 템플릿만 적용: TEMPLATE_SIZE 기준으로 변환
//     const BW = TEMPLATE_SIZE.w;
//     const BH = TEMPLATE_SIZE.h;

//     const left = (PHOTO_BOX_TEMPLATE.x1 / BW) * canvasWidth;
//     const top = (PHOTO_BOX_TEMPLATE.y1 / BH) * canvasHeight;
//     const width = ((PHOTO_BOX_TEMPLATE.x2 - PHOTO_BOX_TEMPLATE.x1) / BW) * canvasWidth;
//     const height = ((PHOTO_BOX_TEMPLATE.y2 - PHOTO_BOX_TEMPLATE.y1) / BH) * canvasHeight;

//     // 테두리/라인 보존용 패딩 (필요 시 0~10 조절)
//     const pad = 2;

//     return {
//       left: left + pad,
//       top: top + pad,
//       width: width - pad * 2,
//       height: height - pad * 2,
//     };
//   };
//   const getPhotoSlot1081 = () => {
//   return {
//     left: 24,
//     top: 278,
//     width: 190,
//     height: 260,
//   };
// };

// const getPhotoSlot1082 = () => {
//   return {
//     left: 40,     // ← 좌측 여백 시작
//     top: 160,      // ← 상단 위치
//     width: 360,   // ← 사진 들어갈 영역 폭
//     height: 360,  // ← 높이
//   };
// };

// const getPhotoSlot1083 = () => {
//   return {
//     left: 60,     // ← 좌측 여백 시작
//     top: 221,      // ← 상단 위치
//     width: 178,   // ← 사진 들어갈 영역 폭
//     height: 222,  // ← 높이
//   };
// };

// const getPhotoSlotByCompCode = () => {
//   if (Number(compCodeState) === 1081) {
//     console.log('👉 1081 전용 PHOTO SLOT 적용');
//     return getPhotoSlot1081();
//   }
//   if (Number(compCodeState) === 1082) {
//     console.log('👉 1082 전용 PHOTO SLOT 적용');
//     return getPhotoSlot1082();
//   }

//   if (Number(compCodeState) === 1083) {
//     console.log('👉 1083 전용 PHOTO SLOT 적용');
//     return getPhotoSlot1083();
//   }

//   console.log('👉 기본 PHOTO SLOT 적용');
//   console.log(compCodeState);
//   return getPhotoSlot();
// };

//   // 캡처
//   const captureCanvas = async (): Promise<string | null> => {
//     if (!canvasRef.current) return null;

//     if (document.fonts?.ready) {
//       await document.fonts.ready;
//     }

//     const canvas = await html2canvas(canvasRef.current, {
//       scale: 4,
//       useCORS: true,
//       backgroundColor: null,
//       onclone: (clonedDoc) => {
//         const overlays = clonedDoc.querySelectorAll<HTMLElement>('.overlay-text');
//         overlays.forEach((el) => {
//           const cs = clonedDoc.defaultView?.getComputedStyle(el);
//           if (!cs) return;
//           const top = parseFloat(cs.top || '0');
//           el.style.top = `${top - 17}px`;
//         });
//       },
//     });

//     return canvas.toDataURL('image/png');
//   };

//   const handleDownload = async () => {
//     const dataUrl = await captureCanvas();
//     if (!dataUrl) return;

//     const link = document.createElement('a');
//     link.href = dataUrl;
//     link.download = '사진기록증.png';
//     link.click();
//   };

//   const handleReset = () => {
//     setUserImageUrl('');
//     setTempImageUrl('');
//   };

//   // 레이아웃 없는 대회 예외 처리
//   if (!userImageUrl && layoutConfig === null) {
//     return (
//       <div className="flex justify-center items-start h-screen bg-white pt-40">
//         <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">이번 대회에서는 사진 기록증을 서비스하지 않습니다.</h1>
//       </div>
//     );
//   }

//   // 초기 화면: 갤러리 + 업로드
//   if (!userImageUrl) {
//     const imgSize = 320;

//     return (
//       <div className="flex flex-col items-center">
//         <div className="flex items-center mb-4">
//           <Button size="sm" onClick={prevPage} disabled={!visible.length || currentIndex === 0}>
//             ◀
//           </Button>

//           <div className="flex mx-2">
//             {visible.map((fn, idx) => {
//               const url = `/static/images/${compCodeState}/${fn}`;
//               return (
//                 <div key={idx} className="flex flex-col items-center m-2">
//                   <img
//                     src={url}
//                     alt="gallery"
//                     style={{ width: imgSize, height: 'auto', objectFit: 'cover', cursor: 'pointer' }}
//                     onClick={() => openModal(url)}
//                   />
//                   <div className="mt-2 flex space-x-2">
//                     <Button size="sm" onClick={() => setUserImageUrl(url)}>
//                       기록증 만들기
//                     </Button>
//                     <Button size="sm" onClick={() => handleDownloadImage(url)}>
//                       다운로드
//                     </Button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <Button size="sm" onClick={nextPage} disabled={currentIndex + pageSize >= serverImages.length}>
//             ▶
//           </Button>
//         </div>

//         {modalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="relative flex justify-center items-center max-w-[80vw] max-h-[80vh]">
//               <img
//                 src={modalUrl}
//                 alt="enlarged"
//                 style={{
//                   maxWidth: '50%',
//                   maxHeight: '50%',
//                   transform: `scale(${zoom})`,
//                   transformOrigin: 'center center',
//                 }}
//                 onWheel={(e) => {
//                   e.preventDefault();
//                   setZoom((z) => Math.min(Math.max(z + (e.deltaY > 0 ? -0.1 : 0.1), 0.5), 3));
//                 }}
//               />
//               <div className="absolute bottom-2 center-2 flex space-x-2">
//                 <Button size="sm" onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
//                   +
//                 </Button>
//                 <Button size="sm" onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
//                   -
//                 </Button>
//                 <Button size="sm" onClick={closeModal}>
//                   닫기
//                 </Button>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="w-full px-6 py-4 mt-6" style={{ backgroundColor: '#e5f1ff' }}>
//           <p className="text-center mb-3 font-medium">현장 촬영 사진으로 기록증 등록 가능합니다.</p>
//           <div className="flex items-center justify-center space-x-4">
//             <span className="font-medium">사진 등록</span>
//             <input type="file" accept="image/*" onChange={handleTempFileChange} />
//             <Button variant="filled" color="blue" onClick={handleUploadClick} disabled={!tempImageUrl}>
//               올리기
//             </Button>
//             <Button variant="outlined" onClick={() => navigate(-1)}>
//               이전
//             </Button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // 기록증 뷰
//   const mapping: Record<string, string> = {
//     name: userName,
//     bib: userBib,
//     div: compDivLs,
//     time: compRecord,
//   };

//   // const PHOTO_SLOT = getPhotoSlot();
//   const PHOTO_SLOT = getPhotoSlotByCompCode();
//   console.log('PHOTO_SLOT:', PHOTO_SLOT);

//   return (
//     <div className="flex flex-col items-center">
//       {/* ✅ 모바일에서 화면 폭 안에 들어오게 스케일링하는 wrapper */}
//       <div
//         ref={wrapperRef}
//         style={{
//           width: '100%',
//           maxWidth: canvasWidth,
//           padding: '0 8px',
//           boxSizing: 'border-box',
//         }}
//       >
//         {/* ✅ 스케일 적용 후 실제 표시 영역 크기 */}
//         <div
//           style={{
//             width: canvasWidth * viewScale,
//             height: canvasHeight * viewScale,
//             margin: '0 auto',
//           }}
//         >
//           {/* ✅ 내부는 원본 좌표계 유지 + transform으로만 축소 */}
//           <div
//             ref={canvasRef}
//             className="mt-2 mb-4 md:mt-8"
//             style={{
//               position: 'relative',
//               width: canvasWidth,
//               height: canvasHeight,
//               backgroundColor: '#fff',
//               transform: `scale(${viewScale})`,
//               transformOrigin: 'top left',
//             }}
//           >
//             {/* 배경 */}
//             <img
//               src={backgroundUrl}
//               alt="background"
//               onLoad={() => setBgReady(true)}
//               style={{
//                 position: 'absolute',
//                 inset: 0,
//                 width: '100%',
//                 height: '100%',
//                 objectFit: 'cover',
//               }}
//             />

//             {/* 텍스트 오버레이 */}
//             {layoutConfig?.texts.map((item, idx) => {
//               const { family, size } = parseFont(item.font);
//               return (
//                 <div
//                   key={idx}
//                   className="overlay-text"
//                   style={{
//                     position: 'absolute',
//                     left: item.x,
//                     top: item.y,
//                     transform: 'translate(-50%, 0)',
//                     textAlign: 'center',
//                     fontFamily: family,
//                     fontSize: size,
//                     color: item.color,
//                     whiteSpace: 'nowrap',
//                   }}
//                 >
//                   {mapping[item.custom_id] || item.text}
//                 </div>
//               );
//             })}

//             {/* ✅ 사용자 사진: 이번 템플릿의 "사진" 영역에 정확히 꽂기 */}
//             <div
//               style={{
//                 position: 'absolute',
//                 left: PHOTO_SLOT.left,
//                 top: PHOTO_SLOT.top,
//                 width: PHOTO_SLOT.width,
//                 height: PHOTO_SLOT.height,
//                 overflow: 'hidden',
//                 border: '2px solid #fff',
//                 boxShadow: '0 0 8px rgba(0,0,0,0.35)',
//                 background: '#fff',
//               }}
//             >
//           <div style={{ position: 'relative', width: '100%', height: '100%' }}>
//             <div
//               style={{
//                 position: 'absolute',
//                 inset: 0,
//                 backgroundImage: `url("${userImageUrl}")`,
//                 backgroundRepeat: 'no-repeat',
//                 backgroundPosition: 'center',
//                 backgroundSize: 'contain', // 원본 비율 유지, 잘림 없음
//                 backgroundColor: '#fff',   // 여백은 흰색 그대로
//               }}
//               ref={(el) => {
//                 if (!el) return;
//                 const img = new Image();
//                 img.onload = () => setUserReady(true);
//                 img.src = userImageUrl;
//               }}
//             />
//           </div>
//               {/* <div
//                 style={{
//                   width: '100%',
//                   height: '100%',
//                   backgroundImage: `url("${userImageUrl}")`,
//                   backgroundRepeat: 'no-repeat',
//                   backgroundPosition: 'center',
//                   backgroundSize: 'cover', // ✅ "사진" 영역을 꽉 채우기
//                 }}
//                 ref={(el) => {
//                   if (!el) return;
//                   const img = new Image();
//                   img.onload = () => setUserReady(true);
//                   img.src = userImageUrl;
//                 }}
//               /> */}
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="flex space-x-4 mb-8">
//         <Button variant="filled" color="blue" onClick={handleDownload}>
//           다운로드
//         </Button>
//         <Button variant="outlined" onClick={handleReset}>
//           이전화면
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default RecordPhotoPrint;

// import React, { useEffect, useMemo, useRef, useState } from 'react';
// import { useParams, useLocation, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { Button } from '@material-tailwind/react';
// import defaultBackground from '../../assets/Record/recordprint.jpg';

// interface LayoutText {
//   custom_id: string;
//   text: string;
//   x: number;
//   y: number;
//   font_family?: string;
//   font_size?: number;
//   font?: string; // 구버전 호환
//   color: string;
//   anchor?: 'nw' | 'n' | 'ne' | string;
// }

// interface LayoutPage {
//   base_width?: number;
//   base_height?: number;
//   preview_width?: number;
//   preview_height?: number;
//   orientation?: 'portrait' | 'landscape';
// }

// interface LayoutConfig {
//   version?: number;
//   page?: LayoutPage;
//   texts: LayoutText[];
//   bg_image?: string;
// }

// type PhotoSlot = {
//   left: number;
//   top: number;
//   width: number;
//   height: number;
// };

// const RecordPhotoPrint: React.FC = () => {
//   const { bibNum } = useParams<{ bibNum?: string }>();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const stateData = (location.state as any) || {};

//   const [userName] = useState(stateData.userName || '이름 없음');
//   const [userBib] = useState(stateData.compBib || bibNum || '-');
//   const [compDivLs] = useState(stateData.compDivLs || 'Full');
//   const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
//   const [compCodeState, setCompCodeState] = useState<number | null>(stateData.compCode || null);

//   const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
//   const [isReady, setIsReady] = useState(false);

//   const canvasRef = useRef<HTMLCanvasElement>(null);

//   useEffect(() => {
//     if (stateData.compCode) setCompCodeState(stateData.compCode);
//   }, [stateData.compCode]);

//   useEffect(() => {
//     if (!compCodeState) return;

//     axios
//       .get(`/api/get-layout/${compCodeState}?mode=photo`)
//       .then((res) => {
//         const raw = res.data;
//         let parsedObj: LayoutConfig = { texts: [] };

//         if (raw.layout_config) {
//           try {
//             parsedObj = JSON.parse(raw.layout_config);
//           } catch (e) {
//             console.error('JSON parse error', e);
//           }
//         }

//         const finalData: LayoutConfig = {
//           ...parsedObj,
//           bg_image: raw.bg_image,
//           texts: parsedObj.texts || [],
//         };

//         setLayoutConfig(finalData);
//       })
//       .catch((err) => {
//         console.error('레이아웃 불러오기 오류:', err);
//         setLayoutConfig(null);
//       });
//   }, [compCodeState]);

//   const orientation = layoutConfig?.page?.orientation ?? 'portrait';

//   const canvasWidth =
//     layoutConfig?.page?.base_width ??
//     (orientation === 'landscape' ? 842 : 595);

//   const canvasHeight =
//     layoutConfig?.page?.base_height ??
//     (orientation === 'landscape' ? 595 : 842);

//   const backgroundUrl = useMemo(() => {
//     return layoutConfig?.bg_image
//       ? `/static/images/${layoutConfig.bg_image}`
//       : defaultBackground;
//   }, [layoutConfig?.bg_image]);

//   const [displayScale, setDisplayScale] = useState(1);

//   useEffect(() => {
//     const updateScale = () => {
//       const availableWidth = window.innerWidth - 20;
//       const nextScale = Math.min(1, availableWidth / canvasWidth);
//       setDisplayScale(nextScale);
//     };

//     window.addEventListener('resize', updateScale);
//     window.addEventListener('orientationchange', updateScale);
//     updateScale();

//     return () => {
//       window.removeEventListener('resize', updateScale);
//       window.removeEventListener('orientationchange', updateScale);
//     };
//   }, [canvasWidth]);

//   const [serverImages, setServerImages] = useState<string[]>([]);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const pageSize = 2;

//   useEffect(() => {
//     if (!userBib || !compCodeState) return;

//     axios
//       .get<string[]>(`/api/get-bib-images/${compCodeState}/${userBib}`)
//       .then((res) => setServerImages(res.data))
//       .catch((err) => {
//         console.error('사진 목록 불러오기 오류:', err);
//         setServerImages([]);
//       });
//   }, [userBib, compCodeState]);

//   const visible = serverImages.slice(currentIndex, currentIndex + pageSize);

//   const prevPage = () => setCurrentIndex((i) => Math.max(i - pageSize, 0));
//   const nextPage = () =>
//     setCurrentIndex((i) => Math.min(i + pageSize, Math.max(serverImages.length - pageSize, 0)));

//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalUrl, setModalUrl] = useState('');
//   const [zoom, setZoom] = useState(1);

//   const openModal = (url: string) => {
//     setModalUrl(url);
//     setZoom(1);
//     setModalOpen(true);
//   };

//   const closeModal = () => setModalOpen(false);

//   const [tempImageUrl, setTempImageUrl] = useState('');
//   const [userImageUrl, setUserImageUrl] = useState('');

//   const handleTempFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const file = e.target.files?.[0];
//     if (file) setTempImageUrl(URL.createObjectURL(file));
//   };

//   const handleUploadClick = () => {
//     if (tempImageUrl) {
//       setUserImageUrl(tempImageUrl);
//       setTempImageUrl('');
//     }
//   };

//   const handleReset = () => {
//     setUserImageUrl('');
//     setTempImageUrl('');
//     setIsReady(false);
//   };

//   const handleDownloadImage = async (url: string) => {
//     try {
//       const resp = await axios.get(url, { responseType: 'blob' });
//       const blobUrl = URL.createObjectURL(resp.data);
//       const link = document.createElement('a');
//       link.href = blobUrl;
//       link.download = url.split('/').pop() || 'image.jpg';
//       link.click();
//       URL.revokeObjectURL(blobUrl);
//     } catch (error) {
//       console.error('원본 이미지 다운로드 오류:', error);
//     }
//   };

//   const mapping: Record<string, string> = {
//     name: userName,
//     bib: userBib,
//     div: compDivLs,
//     time: compRecord,
//   };

//   const parseFont = (item: LayoutText): { family: string; size: number } => {
//     if (item.font_family && item.font_size) {
//       return {
//         family: item.font_family,
//         size: item.font_size,
//       };
//     }

//     const rawFont = item.font || 'Arial 20';
//     const parts = rawFont.trim().split(/\s+/);

//     if (parts.length === 1) {
//       return { family: parts[0], size: 20 };
//     }

//     const last = parts[parts.length - 1];
//     const parsedSize = parseInt(last.replace('px', ''), 10);

//     if (Number.isFinite(parsedSize)) {
//       return {
//         family: parts.slice(0, -1).join(' ') || 'Arial',
//         size: parsedSize,
//       };
//     }

//     return { family: rawFont, size: 20 };
//   };

//   const getCanvasAnchorStyle = (
//     anchor?: string
//   ): { textAlign: CanvasTextAlign; textBaseline: CanvasTextBaseline } => {
//     switch (anchor) {
//       case 'nw':
//         return { textAlign: 'left', textBaseline: 'top' };
//       case 'ne':
//         return { textAlign: 'right', textBaseline: 'top' };
//       case 'n':
//       default:
//         return { textAlign: 'center', textBaseline: 'top' };
//     }
//   };

//   const loadImage = (src: string): Promise<HTMLImageElement> => {
//     return new Promise((resolve, reject) => {
//       const img = new Image();
//       img.crossOrigin = 'anonymous';
//       img.onload = () => resolve(img);
//       img.onerror = reject;
//       img.src = src;
//     });
//   };

//   const getPhotoSlot1081 = (): PhotoSlot => ({
//     left: 24,
//     top: 278,
//     width: 190,
//     height: 260,
//   });

//   const getPhotoSlot1082 = (): PhotoSlot => ({
//     left: 40,
//     top: 160,
//     width: 360,
//     height: 360,
//   });

//   const getPhotoSlot1083 = (): PhotoSlot => ({
//     left: 60,
//     top: 221,
//     width: 178,
//     height: 222,
//   });

//     const getPhotoSlot1092 = (): PhotoSlot => ({
//     left: 70,
//     top: 220,
//     width: 178,
//     height: 215,
//   });

//   const getDefaultPhotoSlot = (): PhotoSlot => {
//     // 기본 안전값: 좌측 상단 근처 사각형
//     return {
//       left: 40,
//       top: 160,
//       width: 180,
//       height: 220,
//     };
//   };

//   const getPhotoSlotByCompCode = (): PhotoSlot => {
//     if (Number(compCodeState) === 1081) return getPhotoSlot1081();
//     if (Number(compCodeState) === 1082) return getPhotoSlot1082();
//     if (Number(compCodeState) === 1083) return getPhotoSlot1083();
//     if (Number(compCodeState) === 1092) return getPhotoSlot1092();
//     return getDefaultPhotoSlot();
//   };

//   const drawUserPhoto = async (
//     ctx: CanvasRenderingContext2D,
//     photoUrl: string,
//     slot: PhotoSlot
//   ) => {
//     const userImg = await loadImage(photoUrl);

//     ctx.save();

//     ctx.fillStyle = '#ffffff';
//     ctx.fillRect(slot.left, slot.top, slot.width, slot.height);

//     const imgRatio = userImg.width / userImg.height;
//     const slotRatio = slot.width / slot.height;

//     let drawW = slot.width;
//     let drawH = slot.height;
//     let drawX = slot.left;
//     let drawY = slot.top;

//     // contain 방식
//     if (imgRatio > slotRatio) {
//       drawW = slot.width;
//       drawH = drawW / imgRatio;
//       drawY = slot.top + (slot.height - drawH) / 2;
//     } else {
//       drawH = slot.height;
//       drawW = drawH * imgRatio;
//       drawX = slot.left + (slot.width - drawW) / 2;
//     }

//     ctx.drawImage(userImg, drawX, drawY, drawW, drawH);

//     ctx.strokeStyle = '#ffffff';
//     ctx.lineWidth = 2;
//     ctx.strokeRect(slot.left, slot.top, slot.width, slot.height);

//     ctx.restore();
//   };

//   const drawCertificate = async () => {
//     if (!layoutConfig || !canvasRef.current || !userImageUrl) return;

//     const canvas = canvasRef.current;
//     const ctx = canvas.getContext('2d');
//     if (!ctx) return;

//     canvas.width = canvasWidth;
//     canvas.height = canvasHeight;

//     ctx.clearRect(0, 0, canvasWidth, canvasHeight);

//     try {
//       if ((document as any).fonts?.ready) {
//         await (document as any).fonts.ready;
//       }

//       const bgImg = await loadImage(backgroundUrl);
//       ctx.drawImage(bgImg, 0, 0, canvasWidth, canvasHeight);

//       const photoSlot = getPhotoSlotByCompCode();
//       await drawUserPhoto(ctx, userImageUrl, photoSlot);

//       for (const item of layoutConfig.texts) {
//         const { family, size } = parseFont(item);
//         const text = mapping[item.custom_id] ?? item.text ?? item.custom_id;
//         const { textAlign, textBaseline } = getCanvasAnchorStyle(item.anchor);

//         ctx.font = `${size}px ${family}`;
//         ctx.fillStyle = item.color || '#000000';
//         ctx.textAlign = textAlign;
//         ctx.textBaseline = textBaseline;

//         ctx.fillText(text, item.x, item.y);
//       }

//       setIsReady(true);
//     } catch (error) {
//       console.error('Canvas draw error:', error);
//       setIsReady(false);
//     }
//   };

//   useEffect(() => {
//     setIsReady(false);
//     if (layoutConfig && userImageUrl) {
//       drawCertificate();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [layoutConfig, backgroundUrl, userImageUrl, userName, userBib, compDivLs, compRecord]);

//   const handleDownload = async () => {
//     if (!canvasRef.current || !userImageUrl) return;

//     await drawCertificate();

//     const dataUrl = canvasRef.current.toDataURL('image/png');
//     const link = document.createElement('a');
//     link.href = dataUrl;
//     link.download = '사진기록증.png';
//     link.click();
//   };

//   if (!userImageUrl && layoutConfig === null) {
//     return (
//       <div className="flex justify-center items-start h-screen bg-white pt-40">
//         <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">
//           이번 대회에서는 사진 기록증을 서비스하지 않습니다.
//         </h1>
//       </div>
//     );
//   }

//   if (!userImageUrl) {
//     const imgSize = 320;

//     return (
//       <div className="flex flex-col items-center">
//         <div className="flex items-center mb-4">
//           <Button size="sm" onClick={prevPage} disabled={!visible.length || currentIndex === 0}>
//             ◀
//           </Button>

//           <div className="flex mx-2">
//             {visible.map((fn, idx) => {
//               const url = `/static/images/${compCodeState}/${fn}`;
//               return (
//                 <div key={idx} className="flex flex-col items-center m-2">
//                   <img
//                     src={url}
//                     alt="gallery"
//                     style={{
//                       width: imgSize,
//                       height: 'auto',
//                       objectFit: 'cover',
//                       cursor: 'pointer',
//                     }}
//                     onClick={() => openModal(url)}
//                   />
//                   <div className="mt-2 flex space-x-2">
//                     <Button size="sm" onClick={() => setUserImageUrl(url)}>
//                       기록증 만들기
//                     </Button>
//                     <Button size="sm" onClick={() => handleDownloadImage(url)}>
//                       다운로드
//                     </Button>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>

//           <Button size="sm" onClick={nextPage} disabled={currentIndex + pageSize >= serverImages.length}>
//             ▶
//           </Button>
//         </div>

//         {modalOpen && (
//           <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
//             <div className="relative flex justify-center items-center max-w-[80vw] max-h-[80vh]">
//               <img
//                 src={modalUrl}
//                 alt="enlarged"
//                 style={{
//                   maxWidth: '50%',
//                   maxHeight: '50%',
//                   transform: `scale(${zoom})`,
//                   transformOrigin: 'center center',
//                 }}
//                 onWheel={(e) => {
//                   e.preventDefault();
//                   setZoom((z) => Math.min(Math.max(z + (e.deltaY > 0 ? -0.1 : 0.1), 0.5), 3));
//                 }}
//               />
//               <div className="absolute bottom-2 center-2 flex space-x-2">
//                 <Button size="sm" onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
//                   +
//                 </Button>
//                 <Button size="sm" onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
//                   -
//                 </Button>
//                 <Button size="sm" onClick={closeModal}>
//                   닫기
//                 </Button>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="w-full px-6 py-4 mt-6" style={{ backgroundColor: '#e5f1ff' }}>
//           <p className="text-center mb-3 font-medium">현장 촬영 사진으로 기록증 등록 가능합니다.</p>
//           <div className="flex items-center justify-center space-x-4">
//             <span className="font-medium">사진 등록</span>
//             <input type="file" accept="image/*" onChange={handleTempFileChange} />
//             <Button variant="filled" color="blue" onClick={handleUploadClick} disabled={!tempImageUrl}>
//               올리기
//             </Button>
//             <Button variant="outlined" onClick={() => navigate(-1)}>
//               이전
//             </Button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="flex flex-col items-center">
//       <div
//         className="mt-8 mb-8 mx-auto bg-white"
//         style={{
//           width: canvasWidth * displayScale,
//           height: canvasHeight * displayScale,
//           overflow: 'hidden',
//         }}
//       >
//         <canvas
//           ref={canvasRef}
//           style={{
//             width: `${canvasWidth * displayScale}px`,
//             height: `${canvasHeight * displayScale}px`,
//             display: 'block',
//             backgroundColor: '#fff',
//           }}
//         />
//       </div>

//       <div className="flex gap-4 mb-4">
//         <Button variant="filled" color="blue" onClick={handleDownload} disabled={!isReady}>
//           다운로드
//         </Button>
//         <Button variant="outlined" onClick={handleReset}>
//           다른 사진 선택
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default RecordPhotoPrint;

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@material-tailwind/react';
import defaultBackground from '../../assets/Record/recordprint.jpg';

interface LayoutText {
  custom_id: string;
  text: string;
  x: number;
  y: number;
  font_family?: string;
  font_size?: number;
  font?: string;
  color: string;
  anchor?: 'nw' | 'n' | 'ne' | string;
}

interface LayoutPage {
  base_width?: number;
  base_height?: number;
  preview_width?: number;
  preview_height?: number;
  orientation?: 'portrait' | 'landscape';
}

interface LayoutConfig {
  version?: number;
  page?: LayoutPage;
  texts: LayoutText[];
  bg_image?: string;
}

type PhotoSlot = {
  left: number;
  top: number;
  width: number;
  height: number;
};

const EXPORT_SCALE = 3;

const RecordPhotoPrint: React.FC = () => {
  const { bibNum } = useParams<{ bibNum?: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const stateData = (location.state as any) || {};

  const [userName] = useState(stateData.userName || '이름 없음');
  const [userBib] = useState(stateData.compBib || bibNum || '-');
  const [compDivLs] = useState(stateData.compDivLs || 'Full');
  const [compRecord] = useState(stateData.compRecord || '기록이 없습니다.');
  const [compCodeState, setCompCodeState] = useState<number | null>(
    stateData.compCode || null
  );

  const [layoutConfig, setLayoutConfig] = useState<LayoutConfig | null>(null);
  const [isReady, setIsReady] = useState(false);

  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (stateData.compCode) setCompCodeState(stateData.compCode);
  }, [stateData.compCode]);

  useEffect(() => {
    if (!compCodeState) return;

    axios
      .get(`/api/get-layout/${compCodeState}?mode=photo`)
      .then((res) => {
        const raw = res.data;
        let parsedObj: LayoutConfig = { texts: [] };

        if (raw.layout_config) {
          try {
            parsedObj = JSON.parse(raw.layout_config);
          } catch (e) {
            console.error('JSON parse error', e);
          }
        }

        const finalData: LayoutConfig = {
          ...parsedObj,
          bg_image: raw.bg_image,
          texts: parsedObj.texts || [],
        };

        setLayoutConfig(finalData);
      })
      .catch((err) => {
        console.error('레이아웃 불러오기 오류:', err);
        setLayoutConfig(null);
      });
  }, [compCodeState]);

  const orientation = layoutConfig?.page?.orientation ?? 'portrait';

  const canvasWidth =
    layoutConfig?.page?.base_width ?? (orientation === 'landscape' ? 842 : 595);

  const canvasHeight =
    layoutConfig?.page?.base_height ?? (orientation === 'landscape' ? 595 : 842);

  const backgroundUrl = useMemo(() => {
    return layoutConfig?.bg_image
      ? `/static/images/${layoutConfig.bg_image}`
      : defaultBackground;
  }, [layoutConfig?.bg_image]);

  const [displayScale, setDisplayScale] = useState(1);

  useEffect(() => {
    const updateScale = () => {
      const availableWidth = window.innerWidth - 20;
      const nextScale = Math.min(1, availableWidth / canvasWidth);
      setDisplayScale(nextScale);
    };

    window.addEventListener('resize', updateScale);
    window.addEventListener('orientationchange', updateScale);
    updateScale();

    return () => {
      window.removeEventListener('resize', updateScale);
      window.removeEventListener('orientationchange', updateScale);
    };
  }, [canvasWidth]);

  const [serverImages, setServerImages] = useState<string[]>([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const pageSize = 2;

  useEffect(() => {
    if (!userBib || !compCodeState) return;

    axios
      .get<string[]>(`/api/get-bib-images/${compCodeState}/${userBib}`)
      .then((res) => setServerImages(res.data))
      .catch((err) => {
        console.error('사진 목록 불러오기 오류:', err);
        setServerImages([]);
      });
  }, [userBib, compCodeState]);

  const visible = serverImages.slice(currentIndex, currentIndex + pageSize);

  const prevPage = () => setCurrentIndex((i) => Math.max(i - pageSize, 0));

  const nextPage = () =>
    setCurrentIndex((i) =>
      Math.min(i + pageSize, Math.max(serverImages.length - pageSize, 0))
    );

  const [modalOpen, setModalOpen] = useState(false);
  const [modalUrl, setModalUrl] = useState('');
  const [zoom, setZoom] = useState(1);

  const openModal = (url: string) => {
    setModalUrl(url);
    setZoom(1);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const [tempImageUrl, setTempImageUrl] = useState('');
  const [userImageUrl, setUserImageUrl] = useState('');

  const handleTempFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    if (tempImageUrl) {
      URL.revokeObjectURL(tempImageUrl);
    }

    setTempImageUrl(URL.createObjectURL(file));
  };

  const handleUploadClick = () => {
    if (!tempImageUrl) return;

    setUserImageUrl(tempImageUrl);
    setTempImageUrl('');
  };

  const handleReset = () => {
    if (userImageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(userImageUrl);
    }

    if (tempImageUrl.startsWith('blob:')) {
      URL.revokeObjectURL(tempImageUrl);
    }

    setUserImageUrl('');
    setTempImageUrl('');
    setIsReady(false);
  };

  const handleDownloadImage = async (url: string) => {
    try {
      const resp = await axios.get(url, { responseType: 'blob' });
      const blobUrl = URL.createObjectURL(resp.data);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = url.split('/').pop() || 'image.jpg';
      link.click();

      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('원본 이미지 다운로드 오류:', error);
    }
  };

  const mapping: Record<string, string> = {
    name: userName,
    bib: userBib,
    div: compDivLs,
    time: compRecord,
  };

  const parseFont = (item: LayoutText): { family: string; size: number } => {
    if (item.font_family && item.font_size) {
      return {
        family: item.font_family,
        size: item.font_size,
      };
    }

    const rawFont = item.font || 'Arial 20';
    const parts = rawFont.trim().split(/\s+/);

    if (parts.length === 1) {
      return { family: parts[0], size: 20 };
    }

    const last = parts[parts.length - 1];
    const parsedSize = parseInt(last.replace('px', ''), 10);

    if (Number.isFinite(parsedSize)) {
      return {
        family: parts.slice(0, -1).join(' ') || 'Arial',
        size: parsedSize,
      };
    }

    return { family: rawFont, size: 20 };
  };

  const getCanvasAnchorStyle = (
    anchor?: string
  ): { textAlign: CanvasTextAlign; textBaseline: CanvasTextBaseline } => {
    switch (anchor) {
      case 'nw':
        return { textAlign: 'left', textBaseline: 'top' };
      case 'ne':
        return { textAlign: 'right', textBaseline: 'top' };
      case 'n':
      default:
        return { textAlign: 'center', textBaseline: 'top' };
    }
  };

  const loadImage = (src: string): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
      const img = new Image();

      img.crossOrigin = 'anonymous';

      img.onload = () => resolve(img);
      img.onerror = reject;

      img.src = src;
    });
  };

  const getPhotoSlot1081 = (): PhotoSlot => ({
    left: 24,
    top: 278,
    width: 190,
    height: 260,
  });

  const getPhotoSlot1082 = (): PhotoSlot => ({
    left: 40,
    top: 160,
    width: 360,
    height: 360,
  });

  const getPhotoSlot1083 = (): PhotoSlot => ({
    left: 60,
    top: 221,
    width: 178,
    height: 222,
  });

  const getPhotoSlot1087 = (): PhotoSlot => ({
    left: 120,
    top: 150,
    width: 220,
    height: 350,
  });

  const getPhotoSlot1092 = (): PhotoSlot => ({
    left: 70,
    top: 220,
    width: 178,
    height: 215,
  });

  const getPhotoSlot1093 = (): PhotoSlot => ({
    left: 70,
    top: 220,
    width: 178,
    height: 215,
  });
  

  const getDefaultPhotoSlot = (): PhotoSlot => ({
    left: 60,
    top: 160,
    width: 180,
    height: 220,
  });

  const getPhotoSlotByCompCode = (): PhotoSlot => {
    if (Number(compCodeState) === 1081) return getPhotoSlot1081();
    if (Number(compCodeState) === 1082) return getPhotoSlot1082();
    if (Number(compCodeState) === 1083) return getPhotoSlot1083();
    if (Number(compCodeState) === 1087) return getPhotoSlot1087();
    if (Number(compCodeState) === 1092) return getPhotoSlot1092();
    if (Number(compCodeState) === 1093) return getPhotoSlot1093();

    return getDefaultPhotoSlot();
  };

  const drawUserPhoto = async (
    ctx: CanvasRenderingContext2D,
    photoUrl: string,
    slot: PhotoSlot
  ) => {
    const userImg = await loadImage(photoUrl);

    ctx.save();

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(slot.left, slot.top, slot.width, slot.height);

    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    const imgRatio = userImg.naturalWidth / userImg.naturalHeight;
    const slotRatio = slot.width / slot.height;

    let drawW = slot.width;
    let drawH = slot.height;
    let drawX = slot.left;
    let drawY = slot.top;

    if (imgRatio > slotRatio) {
      drawW = slot.width;
      drawH = drawW / imgRatio;
      drawY = slot.top + (slot.height - drawH) / 2;
    } else {
      drawH = slot.height;
      drawW = drawH * imgRatio;
      drawX = slot.left + (slot.width - drawW) / 2;
    }

    ctx.drawImage(userImg, drawX, drawY, drawW, drawH);

    ctx.strokeStyle = '#ffffff';
    ctx.lineWidth = 2;
    ctx.strokeRect(slot.left, slot.top, slot.width, slot.height);

    ctx.restore();
  };

  const drawCertificate = async (scale = 1) => {
    if (!layoutConfig || !canvasRef.current || !userImageUrl) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    if (!ctx) return;

    canvas.width = canvasWidth * scale;
    canvas.height = canvasHeight * scale;

    canvas.style.width = `${canvasWidth * displayScale}px`;
    canvas.style.height = `${canvasHeight * displayScale}px`;

    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    try {
      if ((document as any).fonts?.ready) {
        await (document as any).fonts.ready;
      }

      const bgImg = await loadImage(backgroundUrl);
      ctx.drawImage(bgImg, 0, 0, canvasWidth, canvasHeight);

      const photoSlot = getPhotoSlotByCompCode();
      await drawUserPhoto(ctx, userImageUrl, photoSlot);

      for (const item of layoutConfig.texts) {
        const { family, size } = parseFont(item);
        const text = mapping[item.custom_id] ?? item.text ?? item.custom_id;
        const { textAlign, textBaseline } = getCanvasAnchorStyle(item.anchor);

        ctx.font = `${size}px ${family}`;
        ctx.fillStyle = item.color || '#000000';
        ctx.textAlign = textAlign;
        ctx.textBaseline = textBaseline;

        ctx.fillText(text, item.x, item.y);
      }

      setIsReady(true);
    } catch (error) {
      console.error('Canvas draw error:', error);
      setIsReady(false);
    }
  };

  useEffect(() => {
    setIsReady(false);

    if (layoutConfig && userImageUrl) {
      drawCertificate(1);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    layoutConfig,
    backgroundUrl,
    userImageUrl,
    userName,
    userBib,
    compDivLs,
    compRecord,
    displayScale,
  ]);

  const handleDownload = async () => {
    if (!canvasRef.current || !userImageUrl) return;

    await drawCertificate(EXPORT_SCALE);

    const dataUrl = canvasRef.current.toDataURL('image/png', 1.0);

    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = '사진기록증.png';
    link.click();

    await drawCertificate(1);
  };

  if (!userImageUrl && layoutConfig === null) {
    return (
      <div className="flex justify-center items-start h-screen bg-white pt-40">
        <h1 className="text-2xl md:text-4xl font-bold text-center text-red-600">
          이번 대회에서는 사진 기록증을 서비스하지 않습니다.
        </h1>
      </div>
    );
  }

  if (!userImageUrl) {
    const imgSize = 320;

    return (
      <div className="flex flex-col items-center">
        <div className="flex items-center mb-4">
          <Button size="sm" onClick={prevPage} disabled={!visible.length || currentIndex === 0}>
            ◀
          </Button>

          <div className="flex mx-2">
            {visible.map((fn, idx) => {
              const url = `/static/images/${compCodeState}/${fn}`;

              return (
                <div key={idx} className="flex flex-col items-center m-2">
                  <img
                    src={url}
                    alt="gallery"
                    style={{
                      width: imgSize,
                      height: 'auto',
                      objectFit: 'cover',
                      cursor: 'pointer',
                    }}
                    onClick={() => openModal(url)}
                  />

                  <div className="mt-2 flex space-x-2">
                    <Button size="sm" onClick={() => setUserImageUrl(url)}>
                      기록증 만들기
                    </Button>

                    <Button size="sm" onClick={() => handleDownloadImage(url)}>
                      다운로드
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>

          <Button
            size="sm"
            onClick={nextPage}
            disabled={currentIndex + pageSize >= serverImages.length}
          >
            ▶
          </Button>
        </div>

        {modalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative flex justify-center items-center max-w-[80vw] max-h-[80vh]">
              <img
                src={modalUrl}
                alt="enlarged"
                style={{
                  maxWidth: '50%',
                  maxHeight: '50%',
                  transform: `scale(${zoom})`,
                  transformOrigin: 'center center',
                }}
                onWheel={(e) => {
                  e.preventDefault();
                  setZoom((z) =>
                    Math.min(Math.max(z + (e.deltaY > 0 ? -0.1 : 0.1), 0.5), 3)
                  );
                }}
              />

              <div className="absolute bottom-2 center-2 flex space-x-2">
                <Button size="sm" onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
                  +
                </Button>

                <Button size="sm" onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
                  -
                </Button>

                <Button size="sm" onClick={closeModal}>
                  닫기
                </Button>
              </div>
            </div>
          </div>
        )}

        <div className="w-full px-6 py-4 mt-6" style={{ backgroundColor: '#e5f1ff' }}>
          <p className="text-center mb-3 font-medium">
            현장 촬영 사진으로 기록증 등록 가능합니다.
          </p>

          <div className="flex items-center justify-center space-x-4">
            <span className="font-medium">사진 등록</span>

            <input
              type="file"
              accept="image/jpeg,image/png,image/webp"
              onChange={handleTempFileChange}
            />

            <Button
              variant="filled"
              color="blue"
              onClick={handleUploadClick}
              disabled={!tempImageUrl}
            >
              올리기
            </Button>

            <Button variant="outlined" onClick={() => navigate(-1)}>
              이전
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <div
        className="mt-8 mb-8 mx-auto bg-white"
        style={{
          width: canvasWidth * displayScale,
          height: canvasHeight * displayScale,
          overflow: 'hidden',
        }}
      >
        <canvas
          ref={canvasRef}
          style={{
            width: `${canvasWidth * displayScale}px`,
            height: `${canvasHeight * displayScale}px`,
            display: 'block',
            backgroundColor: '#fff',
          }}
        />
      </div>

      <div className="flex gap-4 mb-4">
        <Button variant="filled" color="blue" onClick={handleDownload} disabled={!isReady}>
          다운로드
        </Button>

        <Button variant="outlined" onClick={handleReset}>
          다른 사진 선택
        </Button>
      </div>
    </div>
  );
};

export default RecordPhotoPrint;